import React from 'react';
import DocumentTitle from 'react-document-title';

interface Props {
    title: string;
    variation?: string;
}

const Header: React.SFC<Props> = props => {
    const { children, title, variation } = props;

    return (
        <DocumentTitle title={title}>
            <div className={`header ${variation && `header--${variation}`}`}>
                <div className="header__inner">
                    <div className="row">
                        <div className="column">{children}</div>
                    </div>
                </div>
            </div>
        </DocumentTitle>
    );
};

export default Header;
